<template>
  <section class="py-12 px-4 sm:px-8 xl:px-12 bg-white relative">
    <div class="relative w-full max-w-[1400px] mx-auto flex flex-col lg:flex-row gap-8 items-stretch mt-8">
      
      <!-- Left Card (Blue) -->
      <div class="flex-1 rounded-[2.5rem] p-10 sm:p-14 lg:p-16 relative bg-[#1a66e6] flex flex-col justify-center shadow-xl">
        <!-- Brand logo subtle watermark -->
        <div class="absolute top-8 left-10 opacity-70 flex items-center gap-2">
          <img src="@/assets/tracktalent_logo.svg" alt="TrackTalent" class="h-8 brightness-0 invert" />
        </div>
        
        <div class="relative z-10 space-y-10 mt-12">
          <div class="space-y-4">
            <span class="bg-[#ccff00] text-[#1a66e6] px-4 py-1.5 rounded-full text-sm font-semibold uppercase tracking-wide">
              Outtalent Fellowship
            </span>
            <h2 class="text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight text-white leading-[1.1]">
              Get into big tech.<br/>Faster than everyone else.
            </h2>
          </div>

          <p class="text-lg text-white/90 font-normal leading-relaxed max-w-2xl">
            Outtalent Fellows get exclusive access to real interview recordings, actual offer numbers, direct referrals, and structured prep - everything that gives you an unfair advantage in the hiring process.
          </p>

          <!-- Platform feature grid -->
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
            <div class="bg-white/10 rounded-2xl p-5 space-y-1.5">
              <p class="text-[#ccff00] font-semibold text-base">Referrals</p>
              <p class="text-white/80 text-sm leading-snug">Direct referrals to top companies - no cold applying, no waiting.</p>
            </div>
            <div class="bg-white/10 rounded-2xl p-5 space-y-1.5">
              <p class="text-[#ccff00] font-semibold text-base">InterviewWatch</p>
              <p class="text-white/80 text-sm leading-snug">Exclusive catalog of real big tech interviews - see exactly what to expect.</p>
            </div>
            <div class="bg-white/10 rounded-2xl p-5 space-y-1.5">
              <p class="text-[#ccff00] font-semibold text-base">Offers</p>
              <p class="text-white/80 text-sm leading-snug">Real compensation numbers from real big tech offers - negotiate with confidence.</p>
            </div>
            <div class="bg-white/10 rounded-2xl p-5 space-y-1.5">
              <p class="text-[#ccff00] font-semibold text-base">Campus</p>
              <p class="text-white/80 text-sm leading-snug">Curated knowledge base and structured curriculums for the best interview prep.</p>
            </div>
          </div>

          <!-- CTA -->
          <div class="w-full pt-2">
            <a href="https://outtalent.com" target="_blank" rel="noopener noreferrer">
              <Button class="w-full bg-[#ccff00] text-[#1a66e6] hover:bg-white rounded-full px-8 py-6 text-xl font-semibold shadow-md hover:shadow-lg transition-transform hover:-translate-y-1">
                Apply to Outtalent
              </Button>
            </a>
          </div>
        </div>
      </div>

      <!-- Right Card (Light Gray) -->
      <div class="w-full lg:w-[35%] rounded-[2.5rem] p-10 sm:p-14 bg-[#f0f4f9] flex flex-col justify-center border border-white/50 shadow-sm">
        <div class="space-y-8 flex flex-col items-center text-center lg:items-start lg:text-left">
          <div class="space-y-3">
            <h3 class="text-2xl font-semibold text-gray-900 leading-snug">Or continue with TrackTalent for free.</h3>
            <p class="text-gray-500 text-sm leading-relaxed">
              No Fellowship required. Track your job applications, manage your pipeline, and stay organized - all for free.
            </p>
          </div>

          <div class="w-full">
            <router-link to="/register">
              <Button class="w-full bg-[#1a66e6] text-white hover:bg-black rounded-full px-8 py-6 text-xl font-medium shadow-md hover:shadow-lg transition-transform hover:-translate-y-1">
                Get started free
              </Button>
            </router-link>
          </div>

          <div class="w-full space-y-2.5 pt-2">
            <div class="flex items-start gap-2.5 text-gray-500 text-sm">
              <span class="mt-0.5 text-gray-400">✓</span>
              <span>Unlimited application tracking</span>
            </div>
            <div class="flex items-start gap-2.5 text-gray-500 text-sm">
              <span class="mt-0.5 text-gray-400">✓</span>
              <span>Pipeline & status management</span>
            </div>
            <div class="flex items-start gap-2.5 text-gray-500 text-sm">
              <span class="mt-0.5 text-gray-400">✓</span>
              <span>No credit card needed</span>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </section>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button'
</script>
